module.exports = __webpack_public_path__ + "img/more.92f06e04.svg";